module.exports = __webpack_public_path__ + "media/honey-icons/icon-plus-1b53ba3e.svg";